module.exports = __webpack_public_path__ + "img/slide1.12d496e9.png";